const RED = '#BF2E1A'
const BLUE = '#1b50a6'
const GREEN = '#337a2c'
const GRAY = '#7542f5'
const YELLOW = '#ffef0d'
const ORANGE = '#d96500'
const PURPLE = '#7542f5'
const BLACK = '#000000'
const WHITE = '#ffffff'
const INFO = '#17a2b8'

export {
  RED,
  BLUE,
  GREEN,
  GRAY,
  YELLOW,
  ORANGE,
  PURPLE,
  BLACK,
  WHITE,
  INFO,
}
